// extracted by mini-css-extract-plugin
module.exports = {"container":"SchoolFeedList_container__2bKGZ"};